/* Dirksen Scooters — winkelwagen
   Vanilla JS, defer geladen. Zonder dit script blijft het formulier werken: de
   bijwerkknop post naar /cart met `updates[]` en de verwijderlinks gaan via
   cart_change_url met een regelnummer.

   Met script gaat elke wijziging via /cart/update.js, met de wijzigingen
   benoemd op **regelsleutel** in plaats van op positie. Een positionele reeks
   moet precies zo lang zijn als de winkelwagen regels heeft; zodra er een
   regel bijkomt of verdwijnt tussen het opbouwen en het versturen, schuift
   alles een plek op en verdwijnt het verkeerde artikel. Met sleutels raakt een
   wijziging alleen de regel die je hebt aangewezen.

   Het antwoord bevat de opnieuw gerenderde sectie, zodat elk bedrag door de
   money-filter van Liquid blijft gaan in plaats van hier opgemaakt te worden. */

(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.dkReady === '1') return;
    root.dataset.dkReady = '1';

    var sectionId = root.dataset.dkSection;
    var busy = false;
    // Wijzigingen die tijdens een lopend verzoek zijn aangeklikt. Eerder werden
    // die genegeerd: klikte je twee keer achter elkaar op verwijderen, dan deed
    // de tweede klik niets en bleef het artikel staan.
    var pending = null;

    function lines() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-dk-line]'));
    }

    function lineByKey(key) {
      return root.querySelector('[data-dk-key="' + key + '"]');
    }

    /* Een gekoppelde optie hoort bij een voertuig en gaat dus mee zodra dat
       voertuig weggaat; een windscherm zonder scooter is geen geldige
       bestelling.

       De koppeling loopt over `_group`, een id dat bij het toevoegen op het
       voertuig én zijn opties is gezet. Op titel koppelen was niet genoeg:
       twee uitvoeringen van dezelfde scooter hebben dezelfde titel, en dan
       nam het verwijderen van de ene ook de opties van de andere mee. Voor
       winkelwagens van vóór dat id blijft de titel de terugval. */
    function optionsOf(line) {
      var group = line.dataset.dkGroup;
      var title = line.dataset.dkTitle;
      return lines().filter(function (candidate) {
        if (!candidate.dataset.dkBelongsTo) return false;
        if (group && candidate.dataset.dkGroup) return candidate.dataset.dkGroup === group;
        if (group || candidate.dataset.dkGroup) return false;
        return candidate.dataset.dkBelongsTo === title;
      });
    }

    function mark(keys) {
      keys.forEach(function (key) {
        var line = lineByKey(key);
        if (line) line.classList.add('is-busy');
      });
    }

    /* Wijzigingen als {regelsleutel: aantal}. Loopt er al een verzoek, dan
       worden ze samengevoegd en na afloop verstuurd. */
    function queue(changes) {
      var keys = Object.keys(changes);
      if (keys.length === 0) return;
      mark(keys);

      if (busy) {
        pending = pending || {};
        keys.forEach(function (key) { pending[key] = changes[key]; });
        return;
      }
      send(changes);
    }

    function flush() {
      var next = pending;
      pending = null;
      if (!next) return;

      // Een regel die inmiddels uit de winkelwagen is, heeft geen sleutel meer
      // in de DOM. Die wijziging is dan al doorgevoerd en hoort niet nog een
      // keer mee: Shopify kent de sleutel niet en zou het verzoek afwijzen.
      var live = {};
      Object.keys(next).forEach(function (key) {
        if (lineByKey(key)) live[key] = next[key];
      });
      if (Object.keys(live).length > 0) send(live);
    }

    function send(changes) {
      busy = true;
      root.setAttribute('aria-busy', 'true');

      fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: changes,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('winkelwagen bijwerken mislukte');
          return response.json();
        })
        .then(function (cart) {
          var html = cart.sections && cart.sections[sectionId];
          if (!html) {
            window.location.reload();
            return;
          }
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-dk-cart]');
          if (!fresh) {
            window.location.reload();
            return;
          }
          root.innerHTML = fresh.innerHTML;
          updateHeader(cart);
        })
        .catch(function () {
          // Bij twijfel de pagina laten herladen; dan klopt het beeld zeker.
          pending = null;
          window.location.reload();
        })
        .then(function () {
          busy = false;
          root.removeAttribute('aria-busy');
          flush();
        });
    }

    function updateHeader(cart) {
      var count = document.querySelector('[data-dk-cart-count]');
      if (count) {
        count.textContent = cart.item_count;
        count.classList.toggle('is-empty', cart.item_count === 0);
      }
      // Het totaal in de header komt uit Liquid, dus dat halen we uit de
      // opnieuw gerenderde header in plaats van het hier op te maken.
      fetch(window.location.pathname + '?sections=header')
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = data.header;
          var fresh = wrapper.querySelector('.dk-header__cart-total');
          var current = document.querySelector('.dk-header__cart-total');
          if (fresh && current) current.textContent = fresh.textContent;
        })
        .catch(function () { /* de teller staat al goed */ });
    }

    /* Aantal aanpassen ---------------------------------------------------- */

    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-dk-qty]')) return;

      var line = event.target.closest('[data-dk-line]');
      if (!line || !line.dataset.dkKey) return;

      var qty = parseInt(event.target.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;

      var changes = {};
      changes[line.dataset.dkKey] = qty;

      // Op nul zetten is hetzelfde als verwijderen, dus de gekoppelde opties
      // gaan mee.
      if (qty === 0 && !line.dataset.dkBelongsTo) {
        optionsOf(line).forEach(function (option) {
          if (option.dataset.dkKey) changes[option.dataset.dkKey] = 0;
        });
      }

      queue(changes);
    });

    /* Verwijderen --------------------------------------------------------- */

    root.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-dk-remove]');
      if (!remove) return;
      event.preventDefault();

      var line = remove.closest('[data-dk-line]');
      if (!line || !line.dataset.dkKey) return;

      var changes = {};
      changes[line.dataset.dkKey] = 0;

      if (!line.dataset.dkBelongsTo) {
        optionsOf(line).forEach(function (option) {
          if (option.dataset.dkKey) changes[option.dataset.dkKey] = 0;
        });
      }

      queue(changes);
    });

    /* Bijwerkknop --------------------------------------------------------- */

    root.addEventListener('submit', function (event) {
      // De afrekenknop mag gewoon posten; alleen bijwerken vangen we af.
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'update') return;
      event.preventDefault();

      var changes = {};
      lines().forEach(function (line) {
        var field = line.querySelector('[data-dk-qty]');
        if (!field || !line.dataset.dkKey) return;
        var qty = parseInt(field.value, 10);
        changes[line.dataset.dkKey] = isNaN(qty) || qty < 0 ? 0 : qty;
      });
      queue(changes);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dk-cart]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
